import React from "react";
import Seo from "@/components/Seo";
import Icon from "@/components/Icon";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import CTASection from "@/components/CTASection";
import BrandMarquee from "@/components/Marquee";
import LongForm from "@/components/LongForm";
import { SEO_CONTENT } from "@/data/seoContent";
import { METHODS } from "@/data/site";

export default function Methods() {
  return (
    <>
      <Seo
        title="Nos Méthodes de Détection de Fuite Non Destructive | FuiteX"
        description="Caméra thermique, détecteur acoustique, gaz traceur, endoscopie : découvrez les technologies FuiteX pour localiser une fuite d'eau sans casser."
        canonical="/methodes"
      />
      <PageHero
        overline="Nos méthodes"
        titleLines={["Des méthodes de détection", "100 % non destructives"]}
        subtitle="Localiser une fuite sans casser exige les bons instruments. Voici les technologies que nous combinons pour trouver l'origine exacte du problème."
        breadcrumb={[{ label: "Nos méthodes" }]}
      />

      <section className="bg-white py-24">
        <div className="container-x space-y-6">
          {METHODS.map((m, i) => (
            <Reveal
              key={m.title}
              delay={i * 0.05}
              className="grid lg:grid-cols-12 gap-8 items-center rounded-3xl border border-ink/10 bg-mist/40 p-8 sm:p-10"
            >
              <div className="lg:col-span-2 flex items-center gap-4">
                <span className="text-6xl font-black text-aqua/20">{m.num}</span>
              </div>
              <div className="lg:col-span-2">
                <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-aqua/10 text-aqua">
                  <Icon name={m.icon} size={32} />
                </div>
              </div>
              <div className="lg:col-span-8">
                <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-ink">{m.title}</h2>
                <p className="mt-3 text-lg text-ink/70 leading-relaxed">{m.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <BrandMarquee />

      <section className="bg-ink py-24 grain relative overflow-hidden">
        <div className="container-x relative z-10 max-w-3xl">
          <Reveal>
            <p className="overline text-aqua mb-4">Non destructif vs destructif</p>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
              Pourquoi choisir une méthode non destructive&nbsp;?
            </h2>
            <p className="mt-5 text-lg text-white/70 leading-relaxed">
              La recherche destructive impose de casser murs, sols et dalles « à l'aveugle » pour
              trouver la fuite : des travaux lourds, longs et coûteux. Notre approche non destructive
              localise d'abord le point exact grâce à la technologie, puis ne cible que la zone à réparer.
            </p>
            <p className="mt-4 text-lg text-white/70 leading-relaxed">
              Résultat : moins de dégâts, un chantier plus rapide, une remise en état minimale
              et une facture globale nettement réduite. C'est tout le sens de notre signature —
              <span className="text-aqua font-semibold"> localisation précise, intervention rapide.</span>
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="container-x">
          <LongForm data={SEO_CONTENT.methodes} />
        </div>
      </section>

      <CTASection />
    </>
  );
}
